module.exports = __webpack_public_path__ + "static/img/carme.14c1216e.png";